module.exports = __webpack_public_path__ + "img/close.9a5aee09.svg";